const style = `
    <style>
        .toggle-button-title {
            font-size: 18px;
            line-height: 28px;
            letter-spacing: .54px;
        }
        .payment-option {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            padding: 8px 0;
        }
        .payment-option-wrapper {
            display: flex;
            gap: 18px;
            flex-direction: column;
            width: 100%;
        }
        .payment-option {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            padding: 8px 0;
        }
        .selling-plans-dropdown {
            display: flex;
            width: 100%;
            max-width: 320px;
            position: relative;
            padding-left: 21px;
        }
        .selling-plans-select {
            font-size: 12px;
            line-height: 18px;
            letter-spacing: .12px;
            border: 1px solid #3a3e43;
            width: 100%;
            padding: 8px 12px;
            display: flex;
            border-radius: 11px;
            color: #0a0a0a;
        }
        .unselected-input {
            color: #8f9494
        }

        .price-container {
            gap: 5px;
            display: flex
        }

        .price-through {
          color: #8f9494;
          text-decoration: line-through;
        }

        .input-container {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 5px;
            flex-direction: row-reverse;
        }

        input[type="radio"] {
          display: none;
        }

        label.radio-style {
          display: inline-block;
          width: 10px;
          height: 10px;
          border: 2px solid #8ae5d3;
          border-radius: 50%;
          cursor: pointer;
          position: relative;
        }

        input[type="radio"]:checked + label.radio-style {
          background-color: #8ae5d3;
        }

        label.radio-style::after {
          content: "";
          width: 6px;
          height: 6px;
          background-color: white;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: none;
        }

        input[type="radio"]:checked + label.radio-style::after {
          display: block;
        }

    </style>
`;

export { style };
